import type { FC } from 'react'

import { unit } from '@hcr/ui'
import { isNotNull, isNull } from '@hcr/utils'

import { useHoliday, useUserDetails } from '../../contexts'
import { useDestinationDetailsQuery } from '../../hooks'
import { useHeroQuery } from '../../hooks/api/optimizely/queries'
import { createDestinationDetailsContent } from '../../utils'
import { LayoutNavigationError500 } from '../common'
import { BookingOverviewHome } from '../common/booking-overview/booking-overview-home'

import { HeaderHome, LayoutHome } from './common'
import { HomeDestination } from './HomeDestination'
import { HomeEmpty } from './HomeEmpty'
import { HomeFallback } from './HomeFallback'
import { HomeLoading } from './HomeLoading'

const destinationDetailsContent = createDestinationDetailsContent({ slidesMargin: unit(3) })

export const Home: FC = () => {
  const holiday = useHoliday()
  const userDetails = useUserDetails()
  const isOwner = userDetails?.data?.has_active_contracts
  const hero = useHeroQuery({ isOwner: !!isOwner })

  const destinationDetails = useDestinationDetailsQuery(
    { destinationId: String(holiday.data.destinationId) },
    { enabled: isNotNull(holiday.data.destinationId) }
  )

  if (holiday.isError || hero.isError) {
    return <LayoutNavigationError500 showContextMenuButton />
  }

  if (destinationDetails.isError && hero.isSuccess) {
    return <HomeFallback hero={hero.data} />
  }

  if (
    holiday.isSuccess &&
    hero.isSuccess &&
    isNull(holiday.data.accommodationId) &&
    isNull(holiday.data.destinationId)
  ) {
    return <HomeEmpty hero={hero.data} />
  }

  if (holiday.isSuccess && hero.isSuccess && isNull(holiday.data.accommodationId)) {
    return <HomeDestination hero={hero.data} />
  }

  if (holiday.isSuccess && destinationDetails.isSuccess && hero.isSuccess) {
    return (
      <LayoutHome
        imageUrl={hero.data.imageUrl}
        header={<HeaderHome />}
        bookingOverview={<BookingOverviewHome />}
        content={destinationDetails.data.content.map(destinationDetailsContent)}
      />
    )
  }

  return <HomeLoading />
}
